/*
  MOVIQ: gekozen kleur op productkaarten vasthouden

  snippets/card-gallery.liquid zet op elke foto van een productkaart het attribuut
  data-moviq-block = id van de variantafbeelding (eerste foto) van de kleur waar de foto bij hoort.
  Alleen de foto's van de actieve kleur zijn zichtbaar.

  Klikt iemand op een kleurbolletje, dan worden direct de foto's van die kleur zichtbaar
  en de andere verborgen. Hover (tweede foto), swipen en pijltjes werken daarna alleen
  binnen die kleur; de theme-code (product-card.js) gaat bij hover terug naar de
  variantafbeelding van de gekozen kleur.
  Geladen vanuit layout/theme.liquid.
*/
(function () {
  if (window.__moviqCardColors) return;
  window.__moviqCardColors = true;

  function showColor(card, mediaId) {
    if (!card || !mediaId) return;

    var slides = card.querySelectorAll('slideshow-slide[data-moviq-block]');
    if (!slides.length) return;

    var hasBlock = false;
    slides.forEach(function (slide) {
      if (slide.getAttribute('data-moviq-block') === mediaId) hasBlock = true;
    });
    if (!hasBlock) return;

    slides.forEach(function (slide) {
      slide.hidden = slide.getAttribute('data-moviq-block') !== mediaId;
    });

    var slideshow = card.querySelector('slideshow-component');
    if (slideshow && typeof slideshow.select === 'function') {
      try {
        slideshow.select({ id: mediaId }, undefined, { animate: false });
      } catch (error) {
        /* slideshow nog niet klaar; product-card.js selecteert na het laden alsnog de juiste foto */
      }
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.name || input.name.indexOf('-swatch') === -1) return;

      var card = input.closest('product-card');
      showColor(card, input.dataset.optionMediaId);
    },
    true
  );
})();
